const api = "https://waterlink.utah.gov";

export const appConfig = {
    env: "prod",
    bucketName: "deq-waterlink-prod",
    gqlLink: `${api}/graphql`,
    lslLink: `${api}/lsl`,
    authEndpoint: `${api}/auth`,
    authParams: `?paramkey=%2Fdeq%2Fwaterlink_v2_login`,
    revoke: `${api}/auth/revoke`,
    s3FileDownload: `${api}/s3/file-download`,
    s3FileUpload: `${api}/s3/file-upload`,
    s3GetPresignedUrl: `${api}/s3/get-presigned-url`,
    s3PutPresignedUrl: `${api}/s3/put-presigned-url`,
    s3FileCopy: `${api}/s3/file-copy`,
    s3FileDelete: `${api}/s3/file-delete`,
    wlv1_prefix: "/v1/"
};
